export const inputValidations = {
    // Allows letters (including Spanish accented characters), spaces, hyphens, and apostrophes
    namePattern: /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s'-]*$/,

    alphaNumericCharacters: /^[a-zA-Z0-9]*$/,

    passwordPattern: /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s 0-9!@#$%^&*#_.,]*$/,

    isValidEmail: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,

    // Allows numbers and dots (for document numbers that might include decimals)
    documentPattern: /^[0-9.]*$/,

    // Regex for Colombian passport and foreign ID documents
    // Allows: Letters, numbers, hyphens and spaces
    documentIdPattern: /^[A-Za-z0-9\s-]*$/,

    phonePattern: /^[0-9]{0,10}$/,

    // Only digits (for numeric scores)
    numberPattern: /^[0-9]*$/,

    // Digits and slash for dates like dd/mm/yyyy
    dateSlashPattern: /^[0-9/]*$/,

    isSpecialChar: /[!@#$%^&*]/,

    // A basic email pattern
    // Note: This is a simple pattern and might not catch all valid/invalid emails.
    // For production, consider using a more robust email validation library.
    emailPattern: /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s'0-9.#_?$&*-@/"]*$/,

    // Pattern for addresses - allows letters, numbers, spaces, hyphens and #
    addressPattern: /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ 0-9\s-#]*$/
}

// Helper function to create a regex that allows empty input
export const allowEmpty = (pattern: RegExp): RegExp => {
    return new RegExp(`^(${pattern.source})?$`)
}
